import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function isAiImage(url) {
  if (!url) return false;
  const aiKeywords = [
    "cde68335-833d-4573-a970-b252d22b8ddf", // Lord Sandro
    "ca446636-6dd9-406d-a998-54d74253c1f9", // Cornet's Legacy
    "58291167-ae73-4e02-955e-0576098742cc", // Cornet's Legacy jumping
    "d1935d56-6a48-4bd5-a848-063978f93c9e", // Chacco's Goldy
    "4016965f-9ed1-45e1-bfa1-167f9e667e7b", // Chacco's Goldy jumping
    "31c690f2-621c-4841-8ac8-1f5c7ba85491", // Starlight 311
    "fce7aeab-159d-40f5-8e34-696bcac04849", // Conthargos Blue
    "3cf61034-1bbd-4ddc-b475-c88d1fa6c2bd", // black stallion 1
    "df96b0e5-52e8-4e63-822d-2febfb830ce4", // black stallion 2
    "ed0267af-6908-477f-8896-743291c534d7", // black stallion 3
    "e415581e-c7fa-4e99-9961-fa48671921e9", // dark luxury background
    "15722529-4588-4c0e-8e34-b5442cab42ba", // sponsors background
    "0f3a6664-4100-4b71-8b13-c32d5d909cb0", // training
    "2a239fa8-6a3c-40ba-ba75-e7f0f3675f69"  // jumping
  ];
  return aiKeywords.some(keyword => url.includes(keyword));
}
